import { useEffect } from 'react';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { UseCaseDemos } from '@/sections/UseCaseDemos';
import { trackLandingPageView } from '@/lib/tracking';
import { demosPagePath } from '@/content/site';
import './DemosPage.css';

export function DemosPage() {
  useEffect(() => {
    trackLandingPageView(demosPagePath);
  }, []);

  return (
    <div className="landing-entry">
      <div className="mesh-bg-entry" aria-hidden />
      <Header />
      <main className="demos-page">
        <UseCaseDemos />
      </main>
      <Footer />
    </div>
  );
}
